var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.999,
    height: 6.312,
    viewBox: "0 0 17.999 6.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Collapse_Arrow",
    "data-name": "Collapse Arrow",
    d: "M-1628.592-621.955l-2.25-2.251a.89.89,0,0,1-.19-.3.9.9,0,0,1,0-.685.9.9,0,0,1,.19-.3l2.25-2.251a.9.9,0,0,1,1.279,0,.9.9,0,0,1,0,1.279l-.72.711h4.133a.9.9,0,0,1,.9.9.9.9,0,0,1-.9.9h-4.133l.72.711a.9.9,0,0,1,.266.64.9.9,0,0,1-.266.639.9.9,0,0,1-.639.266A.9.9,0,0,1-1628.592-621.955Zm-8.095,0a.9.9,0,0,1-.266-.639.9.9,0,0,1,.266-.64l.72-.711h-4.133a.9.9,0,0,1-.9-.9.9.9,0,0,1,.9-.9h4.133l-.72-.711a.9.9,0,0,1,0-1.279.9.9,0,0,1,1.278,0l2.251,2.251a.9.9,0,0,1,.19.3.9.9,0,0,1,0,.685.89.89,0,0,1-.19.3l-2.251,2.251a.9.9,0,0,1-.639.266A.9.9,0,0,1-1636.687-621.955Z",
    transform: "translate(1641 628)",
    fill: "#474b4f",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseArrow);
export default __webpack_public_path__ + "static/media/CollapseArrow.2bba36a10f86491cf50b3c027a8743ca.svg";
export { ForwardRef as ReactComponent };